import { useEffect, useState } from "react";
import { ErrorToast, Loading, NotLogin } from "../../shared"
import TabelView from "./tabelView";
import SearchFilter from "./searchFilter";
import { getRestrictedCall } from "../../api/requestAxios/RestrictedCall";
import CustomValuesHook from "../../Hooks/customValuesHook";
import './style.scss'
import { ToPersianNumber } from "../../functions";

const RestrictedCall = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ data: [], pageNumber: 1, pageSize: 50 })

    const currentTime = new Date()
    const lastTime = new Date(+ currentTime.setMonth(currentTime.getMonth() - 3)).toISOString()



    const [params, setParams] = CustomValuesHook({
        // maxCount: 0,
        // minCount: 0,
        // fromDate: "2020-06-16T08:24:07.373Z",
        // toDate: "2024-06-16T08:24:07.373Z",
        // lineStatus: 1,
        // phoneNumber: "",
        pageSize: 50,
        pageNumber: 1,

    })

    // useEffect(() => {
    //     getData()
    // }, [])

    const getData = async (args) => {
        try {
            setLoading(true);
            let tmp = { ...args }
            tmp.pageNumber = args?.pageNumber ? args?.pageNumber : params?.pageNumber
            tmp.PageSize = args?.pageSize ? args?.pageSize : params?.pageSize
            setParams({ pageSize: tmp.PageSize, pageNumber: tmp.pageNumber })

            tmp.fromDate = params?.fromDate;
            tmp.toDate = params?.toDate;
            tmp.lineStatus = params?.lineStatus;
            tmp.phoneNumber = params?.phoneNumber;
            tmp.minCount = params?.minCount;
            tmp.maxCount = params?.maxCount;
            if (!(tmp.phoneNumber)) delete tmp.phoneNumber
            if (!(tmp.maxCount)) delete tmp.maxCount
            if (!(tmp.minCount)) delete tmp.minCount
            if (!(tmp.fromDate)) delete tmp.fromDate
            if (!(tmp.toDate)) delete tmp.toDate
            if (tmp.lineStatus === "all") delete tmp.lineStatus



            const dataAPI = await getRestrictedCall(tmp)

            let temp = { ...data }
            dataAPI?.data?.outputs.forEach((item, index) => {
                tmp.pageNumber !== 1 ? item.row = ((tmp.pageNumber - 1) * tmp.PageSize) + index + 1 : item.row = index + 1

            })


            temp.data = dataAPI?.data?.outputs
            temp.pageNumber = args?.pageNumber ? args?.pageNumber : params?.pageNumber
            temp.totalCount = dataAPI?.data?.total
            setData({ ...temp });

            setLoading(false);


        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
        }
    };


    return (
        <main>
            {!props.login ? (
                <NotLogin></NotLogin>
            ) : (
                <>
                    <div className="top-margin"></div>
                    <div className="user-info-container user-service-container">
                        <div className="user-info line-show">
                            <SearchFilter setParams={setParams} params={params} getData={getData} />
                            <div className="d-flex justify-content-start align-items-center total-count m-3">
                                <span> جمع کل موارد جدول زیر :</span>
                                <span className="mx-2">{ToPersianNumber(data?.data?.length)}</span>
                                <span>خط</span>
                            </div>
                            <TabelView data={data} getData={getData} loading={loading} />
                        </div>
                    </div>

                </>
            )}
        </main>
    )



}

export default RestrictedCall